import React from 'react';
import {
  ExpandableCardsSection,
  ExpandableCardsContainer,
  CardLine,
  SubjectContainer,
} from './styled.SelfAssessmentListSkeleton';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export function SelfAssessmentListSkeleton () {
  const listSkeleton: number[] = [0, 1, 2, 3, 4];

  return (
    <div>
      {listSkeleton.map((index) => (
        <ExpandableCardsSection key={index}>
          <ExpandableCardsContainer>
            <CardLine>
              <Skeleton width={50} />
            </CardLine>
            <div>
              <Skeleton width={20} />
            </div>
            <div>
              <Skeleton width={50} />
            </div>
            <div>
              <Skeleton width={20} />
            </div>
          </ExpandableCardsContainer>
          <SubjectContainer>
            <div>
              <Skeleton width={100} />
            </div>
          </SubjectContainer>
        </ExpandableCardsSection>
      ))}
    </div>
  );
}
